module.exports = __webpack_public_path__ + "static/media/Sec-3_Content_EN_Mobile.f8aede13.webp";